"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardTdcConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcCardTdcConstants = (function () {
    function BcCardTdcConstants() {
    }
    BcCardTdcConstants.CARD_TDC = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc");
    BcCardTdcConstants.CARD_TDC_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-container");
    BcCardTdcConstants.CARD_TDC_SELECTED = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-selected");
    BcCardTdcConstants.CARD_TDC_CURRENCY_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-currency-container");
    BcCardTdcConstants.CARD_TDC_AMOUNT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-amount");
    BcCardTdcConstants.CARD_TDC_LONG_CURRENCY = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-long-currency");
    BcCardTdcConstants.CARD_TDC_HEADER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-header");
    BcCardTdcConstants.CARD_TDC_MINIMUM_PAYMENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-minimum-payment");
    BcCardTdcConstants.CARD_TDC_DUE_DATE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-due-date");
    BcCardTdcConstants.CARD_TDC_TITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-tdc-title");
    return BcCardTdcConstants;
}());
exports.BcCardTdcConstants = BcCardTdcConstants;
